export const formatUnitPrice = (low: number, callLabel: string, numberLocale: string): string => {
  if (!low || low <= 0) return callLabel;
  return `$${low.toLocaleString(numberLocale)}`;
};
